module.exports = __webpack_public_path__ + "img/02_14.9e1fbd3e.jpg";